import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    saveServiceJob(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.serviceJobs}`, context.state.serviceJob).then((res) => {
                if (res.status === 201) {
                    resolve(res)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

    getServiceJobList(context, query) {
        const url = new URL(`${endpoints.BASE_URL}${endpoints.API.serviceJobs}`);
        if (query) {
            url.search = new URLSearchParams(query);
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('get', url).then((res) => {
                if (res.status === 200) {
                    context.commit('setJobList', res.data);
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    fetchServiceJob(context, serviceJobId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceJobs}/${serviceJobId}`).then((res) => {
                if (res.status === 200) {
                    context.commit('setJob', res.data);
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    updateServiceJob(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.serviceJobs}/${context.state.job.serviceJobId}`, context.state.job).then((res) => {
                if (res.status === 200) {
                    context.commit('setJob', res.data);
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        });
    },

    getServiceJobsByService(_, payload) {
        const { serviceId, ...query } = payload;
        const url = new URL(`${endpoints.BASE_URL}${endpoints.API.serviceJobs}/services/${serviceId}`);
        if (query) {
            url.search = new URLSearchParams(query);
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('get', url)
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data)
                    }
                }).catch(err => {
                    reject(err)
                })
        })
    }



}
export default actions;